import {
    GetPaperPlanMappingsInput,
    GetPaperPlanMappingsOutput
} from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';

import { Observable } from 'rxjs';
import { contractConfigurationClient } from 'src/api/client';
import { KeysetPaginator, getAllKeysetPages } from 'src/api/pagination/paginator';

/**
 * Get all paper plan mappings for the given input.
 *
 * The function automates handling of pagination, so any pagination-related
 * fields in the given input will be ignored.
 * @param input The GetPaperPlanMappingsInput to fetch data for.
 */
export function getFullPaperPlanMappings(
    input: GetPaperPlanMappingsInput,
    pageSize: number = 2000
): Promise<GetPaperPlanMappingsOutput> {
    return getAllKeysetPages(new PaperPlanMappingsPaginator(input), pageSize);
}

export class PaperPlanMappingsPaginator implements KeysetPaginator<GetPaperPlanMappingsOutput> {
    private readonly input: GetPaperPlanMappingsInput;
    private output: GetPaperPlanMappingsOutput;

    constructor(input: GetPaperPlanMappingsInput) {
        this.input = input;
        this.output = GetPaperPlanMappingsOutput.clone({
            paperPlanMappings: []
        });
    }

    nextPage(lastEvaluatedId: number | undefined, maxPageSize: number): Observable<GetPaperPlanMappingsOutput> {
        return contractConfigurationClient.getPaperPlanMappings(
            GetPaperPlanMappingsInput.clone({
                ...this.input,
                lastEvaluatedId: lastEvaluatedId,
                maxPageSize: maxPageSize
            })
        );
    }

    accumulate(nextPage: GetPaperPlanMappingsOutput): boolean {
        this.output = {
            paperPlanMappings: [...(this.output.paperPlanMappings || []), ...(nextPage.paperPlanMappings || [])],
            lastEvaluatedId: nextPage.lastEvaluatedId
        };

        return !nextPage.lastEvaluatedId;
    }

    getSize(): number {
        return this.output.paperPlanMappings?.length || 0;
    }

    getValue(): GetPaperPlanMappingsOutput {
        return this.output;
    }
}
